export default {"src":"/_next/static/media/glazier-logo-st-white.32f71a3e.svg","height":300,"width":590,"blurWidth":0,"blurHeight":0};